import { marked } from 'marked';
import { getRelativePageUrl } from 'utils/bolt/index';
import { getCopy } from 'utils/copy';

const markedRenderer = new marked.Renderer();

// link options:
//   - [text](+http://example.com) with + to open in new tab
//   - [text](page) to link to page
markedRenderer.link = (href, title, text) => {
	let attributes = {};
	if (title) attributes.title = title;
	if (href && href[0] === '+') {
		href = href.slice(1);
		attributes.target = '_blank';
	}
	try {
		href = encodeURI(href).replace(/%25/g, '%');
	} catch (e) {
		return text;
	}
	if (href && !/^(https?:|mailto:|#|\/|\.)/.test(href)) {
		const [, page, qs, hash] = href.match(/^(.*?)(\?.+?)?(#.+)?$/) || [];
		href = getRelativePageUrl(page, qs, hash) || '#';
		if (!attributes.target || attributes.target === '_self') {
			attributes.onclick = `event.preventDefault();navigateInternally('${page}'${qs ? `,{queryString:'${qs}'}` : ''});`;
			attributes.role = 'button';
		}
	}
	attributes.href = href;
	let attrString = Object.keys(attributes).map(key => key + '="' + attributes[key] + '"').join(' ');
	return '<a ' + attrString + '>' + text + '</a>';
};

marked.use({
	renderer: markedRenderer,
	hooks: {
		// Replace copy variables
		preprocess: (src) => src.replace(/(\\)?(\$[0-9A-Z_]+)/g, (match, backslash, name) => {
			if (backslash) return name;
			return getCopy(name) || name;
		}),
	}
});

// handle ### Heading {#id}
// based on https://github.com/markedjs/marked-custom-heading-id
const headingIdRegex = /(?: +|^)\{#([a-z][\w-]*)\}(?: +|$)/i;
marked.use({
	useNewRenderer: true,
	renderer: {
		heading({ text, depth }) {
			const idMatch = text.match(headingIdRegex);
			if (!idMatch) return false;
			return `<h${depth} id="${idMatch[1]}">${text.replace(headingIdRegex, '')}</h${depth}>\n`;
		},
	},
});